import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class KnowledgeShareCategoryApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'knowledgeshare-category'
  }

}